__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-09-23-1790167010-stable-dev/";